<template>
	<section class="mbs-wrap mbs016" :style="dBHeight">
        <!-- <modals-container></modals-container> -->
        <section class="mbs-header">
            <div class="inner">
                <div class="tit-box">
                    <h3>{{ $i18nUtil.trans("title.LanguageSetting.001", "다국어 설정") }}</h3>
                </div>
            </div>
        </section>
        <div class="pw-box">
            <ul class="list-table">
				<li>
					<dl>
						<dt>{{ $i18nUtil.trans("message.LanguageSetting.001", "다국어 설정") }}</dt>
						<dd>
							<div style="margin-top: 0px;">
								<ul class="list_dot">
									<li>{{ $i18nUtil.trans("message.LanguageSetting.002", "화면에 표시할 언어를 설정합니다.") }}</li>
								</ul>
							</div>
							<div class="dropdown ty1 right language" style="margin-top: 0px;">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn v-bind="attrs" v-on="on">{{ language.lang }}</v-btn>
									</template>
									<div class="dropdown-list langList">
										<dl class="langList">
											<dd class="langList">
												<ul class="scroll langList">
													<li v-for="language in dfLanguage" :key="language.langCode" class="Langli langList">
														<button type="button" class="ell-singleline" style="font-size: 13px;" @click="setLanguage(language, 1)">
															{{ language.lang }}
														</button>
													</li> 
												</ul>
											</dd>
										</dl>
									</div>
								</v-menu>
							</div>
						</dd>
					</dl>
				</li>
				<!-- <li>
					<dl>
						<dt>{{ $i18nUtil.trans("message.LanguageSetting.003", "타임존 설정") }}</dt>
						<dd>
							<div style="margin-top: 0px;">
								<ul class="list_dot">
									<li>{{ $i18nUtil.trans("message.LanguageSetting.004", "타임존을 설정합니다.") }}</li>
								</ul>
							</div>
							<div class="dropdown ty1 right locale" style="margin-top: 0px;">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn v-bind="attrs" v-on="on">{{ country.country }}</v-btn>
									</template>
									<div class="dropdown-list timezoneList">
										<dl class="timezoneList">
											<dd class="timezoneList">
												<ul class="scroll timezoneList" style="overflow-x: hidden;">
													<li v-for="locale in timezoneList" :key="locale.gmt" class="timezoneLi timezoneList">
														<button type="button" class="ell-singleline" style="font-size:13px; width:685px; text-align:left;" @click="setCountry(locale, 1)">
															{{ locale.country }} | {{ locale.gmt }}
														</button>
													</li> 
												</ul>
											</dd>
										</dl>
									</div>
								</v-menu>
							</div>
						</dd>
					</dl>
				</li> -->
            </ul>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
	created() {
		this.country = this.dfCountry
		this.language = this.dfLanguage[0]
		this.getMyInfo();

		let lang = navigator.language || navigator.userLanguage
		this.browserLanguage = lang.substring(0, 2).toLowerCase() == 'ko' ? 'ko' : 'en';

		// this.getTimezoneList();
		this.getUserLocale();
	},
	data() {
		return {
			toastInfo: {
				obj: this.$toasted,
				message: "",
				options: {
						theme: "toasted-primary",
						position: "bottom-left",
						duration: 3000
				}
			},
			dBHeight: {
				'min-height': (window.innerHeight - 153) + 'px',
			},
			tenantId: localStorage.getItem("tenantId"),
			language: null,
			country: null,

			timezoneList: [],
			dfLanguage: [
				{lang: 'Korean(한국어)', langCode: 'ko'},
				{lang: 'English', langCode: 'en'},
				// {lang: 'Chinese(中国語)', langCode: 'zh'},
				{lang: 'Auto-Detect (Browser language setting)', langCode: ''},
			],
			dfCountry: {
				country: "Asia/Seoul",
				gmt: "(GMT+9:00) Asia/Seoul (Korea Standard Time)"
			},
			browserLanguage: null,
			userInfoKo: {
				userName: null,
				deptName: null
			},
			userInfoEn: {
				userName: null,
				deptName: null
			}
		}
	},
	methods: {
		...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
		...mapActions("modals", ["showModal", "showToast"]),

		/** 사용자가 설정한 DEFAULT_LANGUAGE, COUNTRY 조회 
		 */
		getUserLocale(){ 
			let obj = this;
			let reqData = {};
			reqData.params = {};
			reqData.req = obj.req;
			reqData.url = "/api/auth/locale/getUserLocale";
			reqData.method = "post";

			obj.COWORK_REST_SIMPLE_ACTION(reqData)
				.then(res => {
					if(res.errorCode == null) {
						let result = res.result;
						// DEFAULT_LANGUAGE
						if(result.language == null || result.language == '') {
								/* default setting 사용 안 함
									obj.language = obj.dfLanguage[0]
									obj.setLanguage(obj.language, 0)
								*/
								obj.dfLanguage.forEach(lang => {
								if(lang.langCode === '') {
									obj.language = lang;
								}
							})
						}else{
							let list = obj.dfLanguage
							for(var i=0; i<list.length; i++) {
								if(list[i].langCode == result.language) {
									obj.language = list[i]
									break;
								}
							}
						}
						// COUNTRY
						if(result.country == null || result.country == '') {
							/* default setting */
							obj.setCountry(obj.dfCountry, 0)
						}else{
							obj.country = result.country
						}
					}else{
						console.log(res.errorCode);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		/** Locale 리스트 조회 **/
		getTimezoneList(){ 
			let obj = this;
			let reqData = {};
			reqData.params = {};
			reqData.req = obj.req;
			reqData.url = "/api/auth/locale/getTimezoneList";
			reqData.method = "post";

			obj.COWORK_REST_SIMPLE_ACTION(reqData)
				.then(res => {
					if(res.errorCode == null) {
						let result = res.result
						obj.timezoneList = result
					}else{
						console.log(res.errorCode);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		/** 다국어 설정 **/
		setLanguage(language, set) {
			let okrUse = localStorage.getItem("okrUse");
			if(okrUse) { // okr 메뉴 redis 삭제.
				this.deleteMenuHtmlToRedis();
			}
			let setLanguage = language.langCode
			// console.log('setLanguage > ', setLanguage);

			let obj = this;
			let reqData = {};
			reqData.params = {
				language: setLanguage
			};
			reqData.req = obj.req;
			reqData.url = "/api/auth/locale/setLanguage";
			reqData.method = "post";

			obj.COWORK_REST_SIMPLE_ACTION(reqData)
				.then(res => {
					if(res.errorCode == null) {
						let language = res.result.language == null || res.result.language == '' ? '' : res.result.language;
						for(var i=0; i<obj.dfLanguage.length; i++) {
							if(obj.dfLanguage[i].langCode == language) {
								obj.language = obj.dfLanguage[i]
								break;
							}
						}
						let lang = language == '' ? obj.browserLanguage : language === 'ko' ? language : 'en';
						lang = obj.tenantId === "418502" || obj.tenantId === "201" ? lang+'-'+obj.tenantId : lang;
						// console.log('defaultLanguage', lang);
						localStorage.setItem('defaultLanguage', lang);

						if(obj.$i18nUtil.getLanguage() === 'ko') {
							localStorage.setItem('userName', obj.userInfoKo.userName);
							localStorage.setItem('deptName', obj.userInfoKo.deptName);
						}else{
							localStorage.setItem('userName', obj.userInfoEn.userNameEn != null ? obj.userInfoEn.userNameEn : obj.userInfoEn.userName);
							localStorage.setItem('deptName', obj.userInfoEn.deptNameEn != null ? obj.userInfoEn.deptNameEn : obj.userInfoEn.deptName);
						}

						obj.$i18n.locale = lang;
						// window.location.reload();
						obj.$router.go();
						obj.logoutNeo();
						if(set == 1) {
							// 1: 사용자가 직접 설정 // 0: 디비 null 이어서 자동 설정
							obj.toastInfo.message = obj.$i18nUtil.trans("message.LanguageSetting.005", "언어가 설정되었습니다.");
							obj.showToast(this.toastInfo);
						}
					}else{
						console.log(res.errorCode);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		/** Locale 설정 **/
		setCountry(locale, set) {
			let setCountry = locale.country
			// console.log('locale > ', setCountry);

			let obj = this;
			let reqData = {};
			reqData.params = {
				country: setCountry
			};
			reqData.req = obj.req;
			reqData.url = "/api/auth/locale/setCountry";
			reqData.method = "post";

			obj.COWORK_REST_SIMPLE_ACTION(reqData)
				.then(res => {
					if(res.errorCode == null) {
						obj.country = res.result.country;
						localStorage.setItem('locale', res.result.country.country);
						// window.location.reload();
						obj.$router.go();
						obj.logoutNeo();
						if(set == 1) {
							// 1: 사용자가 직접 설정 // 0: 디비 null 이어서 자동 설정
							obj.toastInfo.message = obj.$i18nUtil.trans("message.LanguageSetting.006", "타임존이 설정되었습니다.");
							obj.showToast(this.toastInfo);
						}
					}else{
						console.log(res.errorCode);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		getMyInfo() {
			let obj = this;
			let reqData = {
					url: "/api/auth/org/getMyInfo",
					method: "post",
			};
			obj
			.COWORK_REST_SIMPLE_ACTION(reqData)
			.then(function(res) {
				if(res.result != null) {
					let userInfo = res.result.orgDeptUserView;
					obj.userInfoKo.userName = userInfo.userName;
					obj.userInfoKo.deptName = userInfo.deptName;

					obj.userInfoEn.userName = userInfo.userNameEn;
					obj.userInfoEn.deptName = userInfo.deptNameEn;
				}
			})
			.catch(function(err) {
					console.log(err);
			});
		},
		/** 성과관리 로그아웃 **/
		logoutNeo() {
      let obj = this;
      let reqData = {
        url : "/neo/logout",
        method : "post"
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        // console.log("################");
        // console.log(res);
        // console.log("################");
      })
      .catch(function(err) {
        console.log(err);
      });
    },
		checkTabLength(val){
			let byteLength = 65;
			let localeBytes = this.getByteLength(val.country);
			let gmtBytes = this.getByteLength(val.gmt);
			if(localeBytes+gmtBytes > byteLength) {
				return true;
			}else{
				return false;
			}
		},
		getByteLength(str) {
			if (str == null || str.length == 0) {
					return 0;
			}
			var size = 0;
			for ( var i = 0; i < str.length; i++) {
					size += this.charByteSize(str.charAt(i));
			}
			return size;
		},
		charByteSize(ch) {
			if (ch == null || ch.length == 0) {
					return 0;
			}
			var charCode = ch.charCodeAt(0);

			if (charCode <= 0x00007F) {
					return 1;
			} else if (charCode <= 0x0007FF) {
					return 2;
			} else if (charCode <= 0x00FFFF) {
					return 2;
			} else {
					return 2;
			}
		},
		deleteMenuHtmlToRedis() {
			let obj = this;
			let reqData  = {
				url :  "/api/org/okr/deleteMenuHtmlToRedis",
				method : "post",
			};
			obj.COWORK_REST_SIMPLE_ACTION(reqData)
			.then(function(res) {
				if (res != null) {
				console.log("deleteMenuHtmlToRedis result :: "+res.result);
				}
			})
			.catch(function (err) {
				console.log(err);
			})
		},
	}
}
</script>

<style scoped>
	.language .v-menu .v-menu__content {
		width: 295px !important;
	}
	.locale .v-menu .v-menu__content {
		width: 690px !important;
	}
	.mbs016 .list-table > li div {
    margin-top: 0px;
	}
	.droplayer.filter-box .v-menu__content, .dropdown.right > .v-menu > .v-menu__content, .droplayer.right > .v-menu > .v-menu__content {
    left: 0px !important;
	}
	.dropdown > .v-menu, .droplayer > .v-menu {
    top: 10px !important;
	}
	.timezoneLi {
		padding: 5px !important;
	}
	.timezoneList {
		width: 685px !important;
	}
	.Langli {
		padding: 5px !important;
	}
	.langList {
		width: 300px !important;
	}
	.dropdown.ty1 .dropdown-list.timezoneList > dl > dd .scroll > li button:hover + .tooltip-b {display: inline-block;}
	.timezoneList ul > li > button + .tooltip-b {
    display: none;
    position: absolute; left: 0; top: 0px; z-index: 1;
	}
	.timezoneList ul > li > button:hover + .tooltip-b {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/LanguageSetting.vue